import { Ban, CalendarSync, Images, ShieldOff, Wallet } from 'lucide-react';
import { useI18n } from '@/hooks/useI18n';

/**
 * Cosa il salvataggio come template porta con sé e cosa lascia indietro.
 *
 * Ogni riga corrisponde a un comportamento reale di `save_itinerary_as_template`
 * (giorni relativi, guests_data vuoto, supplier_status NULL, solo i costi delle
 * attività — markup e totale cliente azzerati da trg_template_costs_only —, path dei
 * media riscritti e file duplicati dal client): se la RPC cambia, questa lista va
 * cambiata con lei.
 */
const NOTES: { key: string; Icon: typeof Ban }[] = [
  { key: 'dates', Icon: CalendarSync },
  { key: 'travelers', Icon: Ban },
  { key: 'suppliers', Icon: ShieldOff },
  { key: 'costs', Icon: Wallet },
  { key: 'media', Icon: Images },
];

export const SaveAsTemplateNotes = () => {
  const { t } = useI18n();

  return (
    <div className="rounded-lg bg-gray-50 border border-gray-200 px-4 py-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        {t('itinerary.saveAsTemplateNotes.title')}
      </p>
      <ul className="space-y-1.5">
        {NOTES.map(({ key, Icon }) => (
          <li key={key} className="flex items-start gap-2 text-sm text-gray-600">
            <Icon className="h-4 w-4 mt-0.5 shrink-0 text-gray-400" />
            <span>{t(`itinerary.saveAsTemplateNotes.${key}`)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
